import { combineReducers } from 'redux';
import LandingPageGridCreate from './LandingPageGrid/LandingPageGridCreate';
import { reducer as landingPageFacetReducer } from './LandingPageFacet';
import jobMatchGridReducer from './JobMatchDetail/JobMatchGridCreate';
import {
  GET_LANDING_PAGE_VIEWS_START,
  GET_LANDING_PAGE_VIEWS_SUCCESS,
  GET_LANDING_PAGE_VIEWS_ERROR,
  GET_LANDING_PAGE_SELECTED_VIEW_START,
  GET_LANDING_PAGE_SELECTED_VIEW_SUCCESS,
  GET_LANDING_PAGE_SELECTED_VIEW_ERROR,
  SET_LANDING_PAGE_SELECTED_VIEW_START,
  SET_LANDING_PAGE_SELECTED_VIEW_SUCCESS,
  SET_LANDING_PAGE_SELECTED_VIEW_ERROR,
  GET_LANDING_PAGE_JOB_DETAILS_START,
  GET_LANDING_PAGE_JOB_DETAILS_SUCCESS,
  GET_LANDING_PAGE_JOB_DETAILS_ERROR,
  ADD_SELECTED_JOBS,
  REMOVE_SELECTED_JOBS,
  CLEAR_ALL_SELECTIONS,
  TOGGLE_EMPLOYEE_FILTER,
  CLEAR_EMPLOYEE_FILTER
} from './LandingPageActions';

const initialState = {
  landingPageSelectedView: {
    selectedViewPk: null,
    loading: false,
    loaded: false,
    status: null,
    error: null
  },
  landingPageJobDetails: null,
  landingPageViews: {
    views: [],
    defaultViewId: null,
    loading: false,
    loaded: false,
    status: null,
    error: null
  },
  excludeJobsWithZeroEmployees: false,
  setLandingPageSelectedView: {
    loading: false
  },
  selectedJobs: []
};

function landingPageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LANDING_PAGE_VIEWS_START: {
      return {
        ...state,
        landingPageViews: {
          views: state.landingPageViews?.views,
          defaultViewId: null,
          loading: true,
          loaded: false,
          status: null,
          error: null
        }
      };
    }
    case GET_LANDING_PAGE_VIEWS_SUCCESS: {
      return {
        ...state,
        landingPageViews: {
          views: action.views,
          defaultViewId: action.defaultViewId,
          loading: false,
          loaded: true,
          status: action.status || 200,
          error: null
        }
      };
    }
    case GET_LANDING_PAGE_VIEWS_ERROR: {
      return {
        ...state,
        landingPageViews: {
          views: [],
          defaultViewId: null,
          loading: false,
          loaded: true,
          status: action.status || 500,
          error: action.message
        }
      };
    }
    case GET_LANDING_PAGE_SELECTED_VIEW_START: {
      return {
        ...state,
        landingPageSelectedView: {
          selectedViewPk: state.landingPageSelectedView?.selectedViewPk,
          loading: true,
          loaded: false,
          status: null,
          error: null
        }
      };
    }
    case GET_LANDING_PAGE_SELECTED_VIEW_SUCCESS: {
      return {
        ...state,
        landingPageSelectedView: {
          selectedViewPk: action.selectedViewPk,
          loading: false,
          loaded: true,
          status: action.status || 200,
          error: null
        }
      };
    }
    case GET_LANDING_PAGE_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        landingPageSelectedView: {
          selectedViewPk: null,
          loading: false,
          loaded: true,
          status: action.status,
          error: action.message
        }
      };
    }
    case SET_LANDING_PAGE_SELECTED_VIEW_START: {
      return {
        ...state,
        setLandingPageSelectedView: {
          loading: true
        }
      };
    }
    case SET_LANDING_PAGE_SELECTED_VIEW_SUCCESS: {
      return {
        ...state,
        setLandingPageSelectedView: {
          loading: false
        },
        landingPageSelectedView: {
          selectedViewPk: action.selectedViewPk,
          loading: false,
          loaded: true,
          status: action.status || 200,
          error: null
        }
      };
    }
    case SET_LANDING_PAGE_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        setLandingPageSelectedView: {
          loading: false
        }
      };
    }
    case GET_LANDING_PAGE_JOB_DETAILS_START: {
      return {
        ...state
      };
    }
    case GET_LANDING_PAGE_JOB_DETAILS_SUCCESS: {
      return {
        ...state,
        landingPageJobDetails: action.landingPageJobDetails
      };
    }
    case GET_LANDING_PAGE_JOB_DETAILS_ERROR: {
      return {
        ...state
      };
    }
    case ADD_SELECTED_JOBS: {
      const { jobs } = action;
      const newSelectedJobs = [...state.selectedJobs];
      newSelectedJobs.push(...jobs);
      return {
        ...state,
        selectedJobs: newSelectedJobs
      };
    }
    case REMOVE_SELECTED_JOBS: {
      const { jobIDs } = action;
      const newSelectedJobs = [...state.selectedJobs];
      jobIDs.forEach(jobID => {
        const index = newSelectedJobs.findIndex(job => job.jobID === jobID);
        if (index === -1) return;
        newSelectedJobs.splice(index, 1);
      });
      return {
        ...state,
        selectedJobs: newSelectedJobs
      };
    }
    case CLEAR_ALL_SELECTIONS: {
      return {
        ...state,
        selectedJobs: []
      };
    }
    case TOGGLE_EMPLOYEE_FILTER: {
      return {
        ...state,
        excludeJobsWithZeroEmployees: !state.excludeJobsWithZeroEmployees
      };
    }
    case CLEAR_EMPLOYEE_FILTER: {
      return {
        ...state,
        excludeJobsWithZeroEmployees: false
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default combineReducers({
  landingPageReducer,
  landingPageGridReducer: LandingPageGridCreate,
  landingPageFacetReducer,
  jobMatchGridReducer
});
